import { EinvoiceValidationresult } from '../../../data/models'
import { EInvoiceAvailableRuleSet } from '../../../data/models/EInvoice'

// Add virus to ValidationType
export interface ExtendedEInvoiceValidationResult
  extends Omit<EinvoiceValidationresult, 'ValidationType'> {
  ValidationType: 'Virus' | EinvoiceValidationresult['ValidationType']
}

// EInvoice
export interface EInvoiceError {
  AvailableRulesets?: EInvoiceAvailableRuleSet[] | null
  FileName?: string | null
  FileSizeInBytes?: number | null
  InvoiceFormat?: number | null
  InvoiceVersion?: string | null
  PdfValidationProfile?: string | null
  Results?: ExtendedEInvoiceValidationResult[] | null
  Status?: EInvoiceStatus
}

export enum EInvoiceStatus {
  Error = 0,
  Warn = 1,
  Success = 2,
}
